import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import styled from "styled-components";
import { Grid, Row, Col } from "@vds/grids";
import { TitleLockup } from "@vds3/type-lockups";
import { Text } from '@vds/core';
import { LayoutTokens } from "@vds-tokens/layout";
import { MarginSpacerM, MarginSpacerS } from "common/components/styleTag";
import { useTranslation } from "react-i18next";

const HeroDiv = styled.div`
  width: 100%;
  margin:40px 0px;
`;

const HeroCopy = ({ pageName, ...props }) => {

    const isMobile = useMediaQuery({
        query: "(max-width: 545px)",
    });
    const { t, ready } = useTranslation(["app", "4G-5G"], { useSuspense: false });
    const [titleRed, setTitleRed] = useState('');
    const [titleBlack, setTitleBlack] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const heroCopyContent = t("4G-5G.heroCopyContent", { ns: "4G-5G", returnObjects: true })

    useEffect(() => {
        if (ready) {
            if (pageName === "GW") {
                setTitleRed(heroCopyContent?.gridwall?.titleRed)
                setTitleBlack(heroCopyContent?.gridwall?.titleBlack)
                setSubTitle(heroCopyContent?.gridwall?.subTitle)
            }else if (pageName === "PDP") {
                setTitleRed(heroCopyContent?.pdp?.titleRed)
                setTitleBlack(heroCopyContent?.pdp?.titleBlack)
                setSubTitle(heroCopyContent?.pdp?.subTitle)
            }
            else if (pageName === "plans") {
                setTitleRed(heroCopyContent?.plans?.titleRed)
                setTitleBlack(heroCopyContent?.plans?.titleBlack)
                setSubTitle(heroCopyContent?.plans?.subTitle)
            }
            else if (pageName === "byod") {
                setTitleRed(heroCopyContent?.byod?.titleRed)
                setTitleBlack(heroCopyContent?.byod?.titleBlack)
                setSubTitle(heroCopyContent?.byod?.subTitle)
            }else{
                setTitleRed(heroCopyContent?.gridwall?.titleRed)
                setTitleBlack(heroCopyContent?.gridwall?.titleBlack)
                setSubTitle(heroCopyContent?.gridwall?.subTitle)
            }
        }
    }, [ready])

    return (
        <HeroDiv isMobile={isMobile}>
            <Grid colSizes={{ mobile: 4, tablet: 12, desktop: 12 }}>
                <Row>
                    <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }}>
                    {pageName === "byod"&&<MarginSpacerS/>}
                        {<Text kind="title" size="xlarge">
                            <span style={{ fontSize: isMobile ? '1.7rem' : '', fontWeight: isMobile ? '500' : '', color: pageName === "byod" ? "#FFFFFF" : "#000000",whiteSpace: 'nowrap' }}>
                                <span style={{ color: pageName === "byod" ? "#FFFFFF" : "#EE0000" }}>{titleRed} </span>
                                {titleBlack}</span>
                        </Text>}
                    </Col>
                </Row>
                <MarginSpacerM />
                <Row>
                    <Col colSizes={{ mobile: 4, tablet: 8, desktop: 8 }} >
                        <Text kind="body" size="large"  >
                            <span style={{ color: pageName === "byod" ? "#FFFFFF" : "#000000" }}
                                dangerouslySetInnerHTML={{
                                    __html: subTitle,
                                }}
                            />
                        </Text>
                    </Col>
                </Row>
            </Grid>
        </HeroDiv>
    );
};

export default HeroCopy;
